import React, { useState, useEffect } from 'react';

import { Row, Divider, Form, Input, Button, Tooltip } from 'antd';
import { MinusCircleOutlined, PlusOutlined, EyeOutlined, EyeInvisibleOutlined, DeleteOutlined } from '@ant-design/icons';

// import fontawesome solid free icons and import trash and eye icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

import ColorPreview from './ColorPreview';

import getColors from 'get-image-colors'

import { t } from '../../../i18n';
import '../index.css';

const ColorPalette = (props) => {
    return (
        <Form name="dynamic_form_item"
            onValuesChange={(event) => {
                props.setColors(event.colors);

            }} >
            <div className='jupapi'>
                <center>
                    <Form.List
                        // initialValue = {props.colors[0][0]}
                        name="colors"
                        rules={[
                            {
                                validator: async (_, names) => {
                                    console.log("The names are", names);
                                    if (!names || names.length < 1) {
                                        return Promise.reject(new Error(t('Select a color')));
                                    }
                                },
                            },
                        ]}
                    >

                        {(fields, { add, remove }, { errors }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item
                                        required={false}
                                        key={field.key}
                                    >
                                        <Row justify="center"
                                        // center the content vertically
                                        align="middle"
                                      

                                        >
                                            <Tooltip title={t("Show/Hide Layer")}>
                                                {fields.length > 1 && props.colors[index][1] == false ? (
                                                    <FontAwesomeIcon icon={faEyeSlash} size={14} style={{paddingRight:"10px"}}onClick={
                                                        () => {
                                                            var newColors = Object.assign([], props.colors);
                                                            newColors[index][1] = !newColors[index][1];
                                                            props.setColors(newColors)
                                                            console.log("fields, ", fields);
                                                        }
                                                    } />

                                                ) : null}
                                                {fields.length > 1 && props.colors[index][1] == true ? (

                                                    <FontAwesomeIcon icon={faEye} size={14} style={{paddingRight:"10px"}}
                                                        onClick={() => {
                                                            var newColors = Object.assign([], props.colors);
                                                            newColors[index][1] = !newColors[index][1];
                                                            props.setColors(newColors)
                                                        }}
                                                    />

                                                ) : null}
                                            </Tooltip>
                                            {fields.length > 0 ? (
                                                <div style={{ paddingTop: "10px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: "#" + props.colors[index][0], width: "35px", height: "35px" }}></div>
                                            ) : null}
                                            <Form.Item
                                                validateTrigger={['onChange', 'onBlur']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        whitespace: true,
                                                        message: t("Please input color or delete this field."),
                                                    },
                                                ]}
                                                noStyle
                                            >
                                                <Input placeholder={t("Color")} style={{ width: 'calc(90% - 70px)' }} value={props.colors[index][0]} />

                                            </Form.Item>


                                            {fields.length > 1 ? (
                                                <FontAwesomeIcon icon={faTrash} size={14} style={{paddingLeft:"10px"}}
                                                    onClick={() => remove(field.name)}
                                                />

                                            ) : null}
                                        </Row>

                                    </Form.Item>
                                ))}
                                <Form.Item>
                                    <Row>

                                        <Button
                                            id='addColor'
                                            type="dashed"
                                            onClick={() => {
                                                console.log("clicked color", props.clickedColor);
                                                add([document.getElementById("status").innerHTML.slice(1), true], 0);
                                            }}
                                            style={{ width: '90%' }}
                                            icon={<PlusOutlined />}
                                        >
                                            {/* <div id="color" style={{ margin:"10px", width: "25px", height: "25px" }} ><div id="status" style={{paddingLeft:"30px"}}></div></div> */}

                                            {t("Click Image")}
                                        </Button>
                                    </Row>
                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </center>
            </div>
            <Divider style={{ margin: '0px' }} />
        </Form>
    );
};

export default ColorPalette;
